<template>
  <div class="category-management">
      <page-title title="筛选">
          <el-row class="category-management__filter-header" :gutter="20">
              <el-col :xl="4" :span="6">
                  <span>买家信息：</span>
                  <el-input v-model="filter.phone" placeholder="请输入"></el-input>
              </el-col>
              <el-col :xl="6" :span="8">
                  <span>交易时间：</span>
                  <el-date-picker
                      v-model="filter.dateTime"
                      type="datetimerange"
                      range-separator="至"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm:ss"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
                    </el-date-picker>
              </el-col>
              <el-col :xl="4" :span="6">
                  <span>操作类型：</span>
                  <el-select v-model="filter.handType" placeholder="请输入" clearable filterable >
                    <el-option v-for="item in payOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  
              </el-col>
              <el-col :xl="3" :span="6">
                  <el-button @click="search">查询</el-button>
                  <el-button @click="reset">重置</el-button>
                  <el-button type="primary"  @click="exportBtn">下载</el-button>
              </el-col>
          </el-row>
      </page-title>
      <page-title title="数据列表">
          <div class="category-management__body">
              <el-table v-loading="loading" :data="tableData" style="width: 100%"
                  :header-cell-style="{ backgroundColor: `#f7f7f7` }">
                  <el-table-column prop="createTime" label="时间" ></el-table-column>
                  <el-table-column prop="code" label="订单号"></el-table-column>
                  <el-table-column prop="handType" label="操作类型">
                      <template slot-scope="scope">
                          {{  ['购买商品', '购买套餐','退款'][scope.row.handType] }}
                      </template>
                  </el-table-column>
                  <el-table-column prop="handResult" label="本次操作"></el-table-column>
                  <el-table-column prop="status" label="状态">
                      <template slot-scope="scope">
                          {{  ['已退款', '购买成功','退款成功'][scope.row.status] }}
                      </template>
                  </el-table-column>
                  <el-table-column prop="value" label="价值"></el-table-column>
                  <el-table-column prop="type" label="套餐类型"></el-table-column>
                  <el-table-column prop="phone" label="买家信息"></el-table-column>
              </el-table>
              <cus-pagination :total="total" :current-page.sync="currentPage" :page-size.sync="pageSize"
                  @size-change="getList"></cus-pagination>
          </div>
      </page-title>
  </div>
</template>

<script>
import PageTitle from '@/components/pageTitle.vue';
import CusPagination from '@/components/cusPagination.vue';
import axios from 'axios';
import { requestUrl} from '../../../config/config';
import {  menuApplyList,menuApplyExport} from '@/api/package';
import { scope } from '@/config/config';
export default {
  components: {
      PageTitle,
      CusPagination,
  },
  data() {
      return {
          apiEnd: false,
          loading: true,
          filter: {
              phone: '',
              dateTime: [],
              handType: '',

          },
          tableData: [
          ],
          currentPage: 1,
          pageSize: 10,
          total: 0,
          dialogVisible: false,
          dialogMode: 'add', // 默认模式
          currentData: {}, // 当前表单数据   
          payOptions:[
              {
                  value: 0,
                  label: '购买商品'
              },
              {
                  value: 1,
                  label: '购买套餐'
              }
          ]
      };
  },
  watch: {
      currentPage() {
          this.getList();
      }
  },
  methods: {
      async getList() {
          this.loading = true;
          const { data } = await this.$ajax.get(menuApplyList, {
              pageSize: this.pageSize,
              pageOn: this.currentPage,
              phone: this.filter.phone,
              handType: this.filter.handType,
              beginTime: this.filter.dateTime ? this.filter.dateTime[0] : '',
              endTime: this.filter.dateTime ? this.filter.dateTime[1] : '',
          });
          this.tableData = data?.data?.records || [];
          this.total = data?.data?.total || 0;
          this.loading = false;
      },
      exportBtn(){
            const params = {
                    phone: this.filter.phone,
                    handType: this.filter.handType,
                    beginTime: this.filter.dateTime ? this.filter.dateTime[0] : '',
                    endTime: this.filter.dateTime ? this.filter.dateTime[1] : '',
                }
            axios({
                url: requestUrl + menuApplyExport,
                method: 'get',
                params: params,
                responseType: 'blob',
                headers: {
                  Authorization: 'Bearer ' + sessionStorage.getItem('token')
                }
              }).then(res => {
                if (!res) return;
                const blob = new Blob([res.data], { type: 'application/vnd.ms-excel,charset=utf-8' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = '套餐消费.xlsx';
                a.click();
                URL.revokeObjectURL(url);
              })
        },
      search() {
          this.getList()
      },
      reset() {
          this.filter.phone = '';
          this.filter.dateTime = [];
          this.filter.handType = '';
          this.getList()
      },
  },
  mounted() {
      this.getList();
  },
};
</script>

<style lang="scss" scoped>
.category-management {
  .box-card {
      margin-bottom: 20px;
  }

  &__filter-header {
      display: flex;
      align-items: center;
  }

  &__body {
      .edit {
          color: #005BFF;
      }

      .el-button.is-disabled {
          color: #C0C4CC;
          cursor: not-allowed;
      }

      .el-switch__label {
          color: #333333;
      }

      .el-table {
          border: 1px solid #ebeef5;
          border-bottom: none;
          margin-bottom: 20px;
      }
  }
}
</style>